import { axiosPath } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    extra_time_list: [],
    extra_store: {}
  },
  mutations: {
    getExtraList(state, data) {
      state.extra_time_list = data;
    },
    getExtraStore(state, data) {
      state.extra_store = data;
    }
  },
  actions: {
    async updateExtraStore({ commit, rootState, dispatch }, form) {
      let url = rootState.api_urls.fetchFoodExtraBack_updateExtraStore;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        return 2;
      }
    },
    async getExtraStore({ commit, rootState, dispatch }) {
      commit("getExtraStore", {});
      let url = rootState.api_urls.fetchFoodExtraBack_updateExtraStore;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getExtraStore", res);
        return res;
      }
    },
    async updateSubExtra({ commit, rootState, dispatch }, form) {
      let url = rootState.api_urls.fetchFoodExtraBack_updateSubExtra;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        commit("getExtraList", res);
        return 2;
      }
    },
    async updateMainExtra({ commit, rootState, dispatch }, form) {
      let url = rootState.api_urls.fetchFoodExtraBack_updateMainExtra;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        commit("getExtraList", res);
        return 2;
      }
    },
    async getExtraList({ commit, rootState, dispatch }) {
      commit("getExtraList", []);
      let url = rootState.api_urls.fetchFoodExtraBack_getExtraList;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getExtraList", res);
        return res;
      }
    }
  }
};
